import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'exerciseLabel',
    standalone: false
})
export class ExerciseLabelPipe implements PipeTransform {

    static format(exercise: Record<string, any>, number = 'Numero', label = 'Libelle'): string {
        return [number, label].map(property => exercise?.[property]).filter(e => !!e).join(' - ');
    }

    transform(exercise: Record<string, any>, number = 'Numero', label = 'Libelle'): string {
        return ExerciseLabelPipe.format(exercise);
    }
}
